var _rect, _rect2, _path, _path2, _text, _path3, _path4, _image, _path5, _path6, _rect3, _text2, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _ellipse, _g, _path15, _path16, _path17, _path18, _ellipse2, _g2, _path19, _path20, _ellipse3, _g3, _path21, _path22, _image2, _path23, _path24, _image3, _text3, _text4, _text5, _text6, _path25, _path26, _image4, _rect4, _path27, _path28, _path29, _path30, _path31, _path32, _text7, _path33, _path34, _text8, _path35, _path36, _text9, _rect5, _text10, _switch;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApiDevOps(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "702px",
    height: "832px",
    viewBox: "-0.5 -0.5 702 832",
    content: "<mxfile host=\"Electron\" modified=\"2022-03-17T03:04:13.740Z\" agent=\"5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) draw.io/16.5.1 Chrome/96.0.4664.110 Electron/16.0.7 Safari/537.36\" etag=\"hakyYvKy9w_Q-IZc8Ijk\" version=\"16.5.1\" type=\"device\"><diagram id=\"qHnaU109PntuK9qI-dVp\" name=\"Page-1\">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</diagram></mxfile>",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "100%",
    x2: "0%",
    y2: "0%",
    id: "mx-gradient-f34482-1-bc1356-1-s-0"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "rgb(188, 19, 86)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgb(243, 68, 130)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "100%",
    x2: "0%",
    y2: "0%",
    id: "mx-gradient-945df2-1-5a30b5-1-s-0"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "rgb(90, 48, 181)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgb(148, 93, 242)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "100%",
    x2: "0%",
    y2: "0%",
    id: "mx-gradient-f78e04-1-d05c17-1-s-0"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "rgb(208, 92, 23)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgb(247, 142, 4)",
      stopOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 50,
    width: 650,
    height: 240,
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeDasharray: "3 3",
    pointerEvents: "all"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 460,
    width: 700,
    height: 370,
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    pointerEvents: "all"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 0 0 L 700 0 L 700 310 L 0 310 Z",
    fill: "none",
    stroke: "#232f3e",
    strokeMiterlimit: 10,
    pointerEvents: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 6.09 7.18 C 6.01 7.18 5.93 7.19 5.85 7.19 C 5.5 7.19 5.15 7.23 4.81 7.32 C 4.53 7.39 4.25 7.49 3.98 7.62 C 3.9 7.65 3.84 7.7 3.79 7.76 C 3.75 7.83 3.74 7.91 3.74 7.99 L 3.74 8.32 C 3.74 8.46 3.79 8.53 3.89 8.53 L 3.99 8.53 L 4.22 8.44 C 4.45 8.35 4.69 8.27 4.94 8.21 C 5.17 8.16 5.41 8.13 5.65 8.13 C 6.04 8.09 6.43 8.2 6.74 8.44 C 6.97 8.74 7.09 9.12 7.05 9.5 L 7.05 9.99 C 6.79 9.93 6.54 9.88 6.29 9.84 C 6.05 9.81 5.81 9.79 5.57 9.79 C 4.98 9.76 4.4 9.94 3.94 10.31 C 3.54 10.65 3.32 11.15 3.34 11.68 C 3.31 12.15 3.49 12.62 3.82 12.96 C 4.18 13.29 4.66 13.46 5.15 13.44 C 5.91 13.45 6.63 13.11 7.11 12.51 C 7.18 12.66 7.24 12.79 7.31 12.91 C 7.38 13.02 7.46 13.12 7.55 13.21 C 7.6 13.27 7.67 13.31 7.75 13.31 C 7.81 13.31 7.87 13.29 7.92 13.25 L 8.34 12.97 C 8.41 12.93 8.46 12.86 8.47 12.77 C 8.47 12.72 8.45 12.67 8.42 12.62 C 8.34 12.47 8.26 12.31 8.21 12.14 C 8.15 11.95 8.12 11.75 8.13 11.55 L 8.14 9.37 C 8.2 8.77 8 8.18 7.59 7.74 C 7.17 7.39 6.64 7.19 6.09 7.18 Z M 19.89 7.19 C 19.78 7.19 19.68 7.19 19.57 7.2 C 19.29 7.2 19 7.24 18.73 7.31 C 18.47 7.38 18.23 7.5 18.02 7.66 C 17.82 7.81 17.66 7.99 17.54 8.21 C 17.42 8.43 17.35 8.67 17.36 8.92 C 17.36 9.27 17.48 9.61 17.69 9.89 C 17.97 10.22 18.34 10.46 18.76 10.56 L 19.72 10.87 C 19.97 10.93 20.2 11.05 20.39 11.22 C 20.51 11.35 20.58 11.51 20.57 11.69 C 20.58 11.94 20.45 12.18 20.23 12.31 C 19.93 12.48 19.6 12.56 19.26 12.54 C 18.99 12.54 18.72 12.51 18.46 12.45 C 18.22 12.4 17.98 12.32 17.75 12.22 L 17.59 12.15 C 17.54 12.14 17.5 12.14 17.46 12.15 C 17.36 12.15 17.31 12.22 17.31 12.36 L 17.31 12.69 C 17.31 12.76 17.32 12.82 17.35 12.89 C 17.4 12.97 17.47 13.03 17.56 13.07 C 17.8 13.19 18.06 13.28 18.32 13.34 C 18.66 13.41 19 13.45 19.35 13.45 L 19.33 13.46 C 19.66 13.45 19.98 13.4 20.29 13.3 C 20.55 13.22 20.8 13.09 21.01 12.92 C 21.21 12.77 21.38 12.57 21.49 12.34 C 21.61 12.1 21.67 11.83 21.66 11.56 C 21.67 11.23 21.56 10.9 21.36 10.63 C 21.09 10.32 20.73 10.09 20.33 9.99 L 19.39 9.69 C 19.13 9.61 18.88 9.49 18.67 9.32 C 18.54 9.2 18.47 9.03 18.47 8.85 C 18.46 8.61 18.58 8.38 18.79 8.25 C 19.06 8.11 19.36 8.05 19.67 8.06 C 20.11 8.06 20.55 8.14 20.96 8.32 C 21.04 8.37 21.12 8.4 21.21 8.41 C 21.31 8.41 21.36 8.34 21.36 8.19 L 21.36 7.88 C 21.37 7.8 21.35 7.72 21.31 7.66 C 21.25 7.59 21.18 7.54 21.11 7.49 L 20.83 7.38 L 20.45 7.27 L 20.01 7.2 C 19.97 7.2 19.93 7.19 19.89 7.19 Z M 16.02 7.36 C 15.94 7.35 15.86 7.38 15.79 7.42 C 15.72 7.5 15.68 7.59 15.66 7.69 L 14.51 12.14 L 13.47 7.71 C 13.45 7.61 13.41 7.52 13.34 7.44 C 13.26 7.39 13.17 7.37 13.07 7.38 L 12.54 7.38 C 12.44 7.37 12.35 7.39 12.27 7.44 C 12.2 7.51 12.15 7.61 12.14 7.71 L 11.09 12.14 L 9.97 7.7 C 9.95 7.6 9.91 7.51 9.84 7.44 C 9.76 7.39 9.67 7.36 9.58 7.37 L 8.92 7.37 C 8.81 7.37 8.76 7.43 8.76 7.54 C 8.77 7.63 8.79 7.72 8.82 7.81 L 10.38 12.95 C 10.4 13.05 10.45 13.14 10.52 13.21 C 10.6 13.26 10.69 13.29 10.78 13.28 L 11.36 13.26 C 11.46 13.27 11.55 13.25 11.63 13.19 C 11.7 13.12 11.74 13.03 11.76 12.93 L 12.79 8.64 L 13.82 12.93 C 13.83 13.03 13.88 13.12 13.95 13.19 C 14.03 13.25 14.12 13.27 14.21 13.26 L 14.79 13.26 C 14.88 13.27 14.97 13.25 15.04 13.2 C 15.11 13.13 15.16 13.03 15.18 12.94 L 16.79 7.79 C 16.84 7.72 16.84 7.63 16.84 7.63 C 16.84 7.59 16.84 7.56 16.84 7.52 C 16.84 7.48 16.82 7.43 16.79 7.4 C 16.76 7.37 16.72 7.35 16.67 7.36 L 16.05 7.36 C 16.04 7.36 16.03 7.36 16.02 7.36 Z M 5.65 10.62 C 5.7 10.62 5.75 10.62 5.8 10.62 L 6.43 10.62 C 6.64 10.64 6.85 10.67 7.06 10.71 L 7.07 11.01 C 7.07 11.21 7.05 11.4 7 11.59 C 6.96 11.75 6.88 11.9 6.77 12.01 C 6.61 12.21 6.39 12.36 6.14 12.44 C 5.91 12.52 5.67 12.56 5.43 12.56 C 5.18 12.6 4.93 12.53 4.73 12.37 C 4.55 12.18 4.46 11.92 4.49 11.66 C 4.47 11.36 4.59 11.08 4.81 10.89 C 5.06 10.72 5.35 10.62 5.65 10.62 Z M 21.04 14.72 C 20.34 14.73 19.51 14.89 18.89 15.33 C 18.69 15.46 18.72 15.63 18.94 15.63 C 19.64 15.54 21.21 15.35 21.5 15.71 C 21.78 16.06 21.19 17.54 20.94 18.21 C 20.86 18.41 21.04 18.49 21.21 18.34 C 22.39 17.36 22.72 15.3 22.46 15 C 22.32 14.85 21.74 14.71 21.04 14.72 Z M 2.65 15.1 C 2.5 15.12 2.42 15.3 2.58 15.44 C 5.29 17.89 8.82 19.23 12.48 19.21 C 15.37 19.22 18.2 18.36 20.59 16.74 C 20.95 16.47 20.64 16.07 20.26 16.23 C 17.87 17.24 15.3 17.76 12.71 17.77 C 9.23 17.78 5.82 16.87 2.81 15.14 C 2.75 15.11 2.7 15.1 2.65 15.1 Z M 0 0 L 25 0 L 25 25 L 0 25 Z",
    fill: "#232f3e",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe flex-start",
      justifyContent: "unsafe flex-start",
      width: 668,
      height: 1,
      paddingTop: 7,
      marginLeft: 32
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #232F3E; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(35, 47, 62)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "AWS Cloud")))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 32,
    y: 19,
    fill: "#232F3E",
    fontFamily: "Helvetica",
    fontSize: "12px"
  }, "AWS Cloud")))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 220 570.04 Q 332.91 570.04 332.9 420.1",
    fill: "none",
    stroke: "#5ebfff",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M 332.9 413.35 L 337.4 422.35 L 332.9 420.1 L 328.4 422.35 Z",
    fill: "#5ebfff",
    stroke: "#5ebfff",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), _image || (_image = /*#__PURE__*/React.createElement("image", {
    x: 159.5,
    y: 539.5,
    width: 60,
    height: 60,
    xlinkHref: "https://avatars.githubusercontent.com/u/44036562?s=280&v=4",
    preserveAspectRatio: "none"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M 25.04 500 C 16.19 500 10 492.79 10 485.12 C 10 475.94 17.39 470 25.15 470 C 32.62 470 40 476.13 40 484.99 C 40 492.93 33.68 500 25.04 500 Z",
    fill: "#0d2636",
    stroke: "none",
    pointerEvents: "all"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M 21.79 496.72 C 21.79 497.36 21.3 497.63 20.56 497.38 C 16.12 495.82 11.86 491.02 11.86 485.02 C 11.86 476.9 18.8 471.79 24.81 471.79 C 32.62 471.79 38.18 478.19 38.18 484.94 C 38.18 490.52 34.59 495.65 29.22 497.45 C 28.61 497.61 28.23 497.29 28.23 496.75 L 28.23 492.85 C 28.23 492.09 27.92 491.29 27.36 490.72 C 29.54 490.47 30.86 489.93 31.88 488.88 C 32.87 487.9 33.32 486.44 33.4 484.65 C 33.46 483.23 33.08 481.84 32.05 480.78 C 32.41 479.91 32.47 478.75 31.92 477.32 C 30.84 477.23 29.61 477.88 28.35 478.66 C 26.14 478.08 23.92 478.01 21.71 478.69 C 20.72 478.05 19.82 477.32 18.1 477.32 C 17.65 478.58 17.58 479.74 17.97 480.76 C 16.74 482.12 16.6 483.46 16.62 484.79 C 16.76 487.36 17.7 488.66 18.74 489.43 C 19.61 490.08 20.82 490.48 22.68 490.75 C 22.18 491.24 21.9 491.83 21.85 492.52 C 20.76 493.01 19.2 493.27 18.14 491.75 C 17.66 490.99 17.01 490.14 15.78 490.14 C 15.57 490.13 15.38 490.21 15.35 490.3 C 15.32 490.4 15.43 490.6 15.57 490.67 C 16.65 491.36 16.82 491.75 17.27 492.69 C 17.67 493.79 18.38 494.21 19.15 494.5 C 19.94 494.78 21.21 494.7 21.79 494.5 Z",
    fill: "#ffffff",
    stroke: "none",
    pointerEvents: "all"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 475,
    width: 80,
    height: 20,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 485,
      marginLeft: 80
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "nowrap"
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 20
    }
  }, "GitHub"))))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 80,
    y: 489,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "GitHub")))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M 190 720 Q 189.96 750.04 289.7 750.04 Q 389.43 750.04 389.41 725.71",
    fill: "none",
    stroke: "#5ebfff",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M 389.4 718.96 L 393.91 727.96 L 389.41 725.71 L 384.91 727.97 Z",
    fill: "#5ebfff",
    stroke: "#5ebfff",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M 190 720 Q 189.96 800.04 399.96 800.04 Q 609.96 800.04 609.99 730.1",
    fill: "none",
    stroke: "#5ebfff",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M 610 723.35 L 614.49 732.36 L 609.99 730.1 L 605.49 732.35 Z",
    fill: "#5ebfff",
    stroke: "#5ebfff",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M 190 690 Q 190 690 190 610.1",
    fill: "none",
    stroke: "#5ebfff",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M 190 603.35 L 194.5 612.35 L 190 610.1 L 185.5 612.35 Z",
    fill: "#5ebfff",
    stroke: "#5ebfff",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M 205 705 L 374.9 705",
    fill: "none",
    stroke: "#5ebfff",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M 381.65 705 L 372.65 709.5 L 374.9 705 L 372.65 700.5 Z",
    fill: "#5ebfff",
    stroke: "#5ebfff",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 190,
    cy: 705,
    rx: 15.000000000000002,
    ry: 15.000000000000002,
    fill: "#000000",
    stroke: "none",
    pointerEvents: "all"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    textAnchor: "middle",
    fontSize: "20px"
  }, /*#__PURE__*/React.createElement("text", {
    x: 189.5,
    y: 749.5
  }, "dev"))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M 400 690 Q 400 690 400 610.1",
    fill: "none",
    stroke: "#5ebfff",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M 400 603.35 L 404.5 612.35 L 400 610.1 L 395.5 612.35 Z",
    fill: "#5ebfff",
    stroke: "#5ebfff",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M 415 705 L 584.9 705",
    fill: "none",
    stroke: "#5ebfff",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M 591.65 705 L 582.65 709.5 L 584.9 705 L 582.65 700.5 Z",
    fill: "#5ebfff",
    stroke: "#5ebfff",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 400,
    cy: 705,
    rx: 15.000000000000002,
    ry: 15.000000000000002,
    fill: "#000000",
    stroke: "none",
    pointerEvents: "all"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    textAnchor: "middle",
    fontSize: "20px"
  }, /*#__PURE__*/React.createElement("text", {
    x: 399.5,
    y: 749.5
  }, "uat"))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M 610 690 Q 610 690 610 610.1",
    fill: "none",
    stroke: "#5ebfff",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M 610 603.35 L 614.5 612.35 L 610 610.1 L 605.5 612.35 Z",
    fill: "#5ebfff",
    stroke: "#5ebfff",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 610,
    cy: 705,
    rx: 15.000000000000002,
    ry: 15.000000000000002,
    fill: "#000000",
    stroke: "none",
    pointerEvents: "all"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    textAnchor: "middle",
    fontSize: "20px"
  }, /*#__PURE__*/React.createElement("text", {
    x: 609.5,
    y: 749.5
  }, "prod"))), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M 400 540 Q 400 540 400 420.1",
    fill: "none",
    stroke: "#5ebfff",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M 400 413.35 L 404.5 422.35 L 400 420.1 L 395.5 422.35 Z",
    fill: "#5ebfff",
    stroke: "#5ebfff",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), _image2 || (_image2 = /*#__PURE__*/React.createElement("image", {
    x: 369.5,
    y: 539.5,
    width: 60,
    height: 60,
    xlinkHref: "https://avatars.githubusercontent.com/u/44036562?s=280&v=4",
    preserveAspectRatio: "none"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M 580 570.04 Q 467.09 570.04 467.09 420.1",
    fill: "none",
    stroke: "#5ebfff",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M 467.09 413.35 L 471.59 422.35 L 467.09 420.1 L 462.59 422.35 Z",
    fill: "#5ebfff",
    stroke: "#5ebfff",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), _image3 || (_image3 = /*#__PURE__*/React.createElement("image", {
    x: 579.5,
    y: 539.5,
    width: 60,
    height: 60,
    xlinkHref: "https://avatars.githubusercontent.com/u/44036562?s=280&v=4",
    preserveAspectRatio: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 705,
      marginLeft: 290
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); background-color: rgb(255, 255, 255); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 20,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      backgroundColor: "rgb(255, 255, 255)",
      whiteSpace: "nowrap"
    }
  }, "merge")))), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 290,
    y: 711,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "20px",
    textAnchor: "middle"
  }, "merge")))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 705,
      marginLeft: 490
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); background-color: rgb(255, 255, 255); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 20,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      backgroundColor: "rgb(255, 255, 255)",
      whiteSpace: "nowrap"
    }
  }, "merge")))), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 490,
    y: 711,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "20px",
    textAnchor: "middle"
  }, "merge")))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 754,
      marginLeft: 313
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); background-color: rgb(255, 255, 255); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 20,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      backgroundColor: "rgb(255, 255, 255)",
      whiteSpace: "nowrap"
    }
  }, "merge")))), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 313,
    y: 760,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "20px",
    textAnchor: "middle"
  }, "merge")))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 794,
      marginLeft: 363
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); background-color: rgb(255, 255, 255); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 20,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      backgroundColor: "rgb(255, 255, 255)",
      whiteSpace: "nowrap"
    }
  }, "merge")))), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 363,
    y: 800,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "20px",
    textAnchor: "middle"
  }, "merge")))), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M 265.8 370.04 L 155 370.04 L 155 179 L 168.63 179",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M 173.88 179 L 166.88 182.5 L 168.63 179 L 166.88 175.5 Z",
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), _image4 || (_image4 = /*#__PURE__*/React.createElement("image", {
    x: 265.3,
    y: 329.5,
    width: 268.39,
    height: 80,
    xlinkHref: "https://files.readme.io/ffb4c59-Serverless.png",
    preserveAspectRatio: "none"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 265.8,
    y: 330,
    width: 268.39,
    height: 80,
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    pointerEvents: "all"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M 253 179 L 393.61 179 L 393.61 99 L 527.82 99",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M 533.07 99 L 526.07 102.5 L 527.82 99 L 526.07 95.5 Z",
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M 253 179 L 393.61 179 L 393.61 219 L 527.82 219",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M 533.07 219 L 526.07 222.5 L 527.82 219 L 526.07 215.5 Z",
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M 175 140 L 253 140 L 253 218 L 175 218 Z",
    fill: "url(#mx-gradient-f34482-1-bc1356-1-s-0)",
    stroke: "none",
    pointerEvents: "all"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M 228.49 179.51 L 234.06 179.51 L 234.06 177.28 L 228.49 177.28 Z M 200.63 192.91 L 206.2 192.91 L 206.2 190.67 L 200.63 190.67 Z M 189.49 192.91 L 197.29 192.91 L 197.29 190.67 L 189.49 190.67 Z M 189.49 186.21 L 202.86 186.21 L 202.86 183.98 L 189.49 183.98 Z M 189.49 172.82 L 199.51 172.82 L 199.51 170.59 L 189.49 170.59 Z M 189.49 179.51 L 226.26 179.51 L 226.26 177.28 L 189.49 177.28 Z M 210.66 204.07 L 185.03 204.07 L 185.03 166.12 L 210.66 166.12 L 210.66 175.05 L 212.89 175.05 L 212.89 165.01 C 212.89 164.39 212.39 163.89 211.77 163.89 L 183.91 163.89 C 183.3 163.89 182.8 164.39 182.8 165.01 L 182.8 205.18 C 182.8 205.8 183.3 206.3 183.91 206.3 L 211.77 206.3 C 212.39 206.3 212.89 205.8 212.89 205.18 L 212.89 182.86 L 210.66 182.86 Z M 245.2 176.17 C 245.2 183.38 238.71 185.89 235.27 186.2 L 217.34 186.21 L 217.34 183.98 L 235.17 183.98 C 235.39 183.95 242.97 183.13 242.97 176.17 C 242.97 169.82 237.25 168.53 236.1 168.34 C 235.53 168.24 235.13 167.72 235.18 167.14 C 235.18 167.12 235.18 167.1 235.18 167.08 C 235.12 163.5 232.92 162.38 231.97 162.06 C 230.19 161.47 228.21 162.03 227.16 163.44 C 226.92 163.77 226.51 163.94 226.1 163.88 C 225.7 163.82 225.36 163.54 225.22 163.15 C 224.53 161.21 223.52 159.95 222.13 158.55 C 218.63 155.08 213.89 154.12 209.46 155.99 C 207.13 156.97 205.1 159.19 203.88 162.09 L 201.83 161.22 C 203.27 157.8 205.74 155.14 208.6 153.93 C 213.89 151.7 219.54 152.84 223.7 156.97 C 224.89 158.17 225.88 159.33 226.65 160.84 C 228.31 159.61 230.55 159.24 232.67 159.94 C 235.38 160.84 237.1 163.2 237.37 166.33 C 241.17 167.28 245.2 170.32 245.2 176.17 Z",
    fill: "#ffffff",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe flex-start",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 225,
      marginLeft: 214
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #232F3E; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(35, 47, 62)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "nowrap"
    }
  }, "CloudFormation")))), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 214,
    y: 237,
    fill: "#232F3E",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "CloudFormation")))), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M 534.19 60 L 612.19 60 L 612.19 138 L 534.19 138 Z",
    fill: "url(#mx-gradient-945df2-1-5a30b5-1-s-0)",
    stroke: "none",
    pointerEvents: "all"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M 566.58 116.43 L 569.85 116.43 L 569.85 114.19 L 566.58 114.19 Z M 572.08 116.43 L 575.42 116.43 L 575.42 114.19 L 572.08 114.19 Z M 558.72 70.78 L 544.24 77.97 L 544.24 122.62 L 558.72 127.52 Z M 560.94 84.99 L 560.94 114.19 L 564.28 114.19 L 564.28 116.43 L 560.94 116.43 L 560.94 129.08 C 560.94 129.44 560.77 129.78 560.48 129.99 C 560.29 130.13 560.06 130.2 559.83 130.2 C 559.71 130.2 559.59 130.18 559.48 130.14 L 542.78 124.5 C 542.32 124.34 542.02 123.91 542.02 123.43 L 542.02 77.27 C 542.02 76.84 542.26 76.45 542.64 76.26 L 559.34 67.97 C 559.68 67.8 560.09 67.82 560.42 68.03 C 560.74 68.23 560.94 68.59 560.94 68.98 L 560.94 82.75 L 564.28 82.75 L 564.28 84.99 Z M 577.64 116.43 L 580.98 116.43 L 580.98 114.19 L 577.64 114.19 Z M 577.72 84.99 L 580.98 84.99 L 580.98 82.75 L 577.72 82.75 Z M 572.15 84.99 L 575.42 84.99 L 575.42 82.75 L 572.15 82.75 Z M 566.58 84.99 L 569.85 84.99 L 569.85 82.75 L 566.58 82.75 Z M 602.14 77.97 L 587.66 70.78 L 587.66 127.52 L 602.14 122.62 Z M 604.36 123.43 C 604.36 123.91 604.06 124.34 603.6 124.5 L 586.9 130.14 C 586.79 130.18 586.67 130.2 586.55 130.2 C 586.32 130.2 586.09 130.13 585.9 129.99 C 585.61 129.78 585.44 129.44 585.44 129.08 L 585.44 116.43 L 583.28 116.43 L 583.28 114.19 L 585.44 114.19 L 585.44 84.99 L 583.28 84.99 L 583.28 82.75 L 585.44 82.75 L 585.44 68.98 C 585.44 68.59 585.64 68.23 585.96 68.03 C 586.29 67.82 586.7 67.8 587.04 67.97 L 603.74 76.26 C 604.12 76.45 604.36 76.84 604.36 77.27 Z M 576.46 92.13 L 574.38 91.33 L 568.81 105.92 L 570.89 106.73 Z M 584 99.26 C 584.43 98.82 584.43 98.11 584 97.67 L 579.54 93.18 L 577.97 94.77 L 581.64 98.47 L 577.97 102.16 L 579.54 103.75 Z M 566.84 103.75 L 562.38 99.26 C 561.95 98.82 561.95 98.11 562.38 97.67 L 566.84 93.18 L 568.41 94.77 L 564.74 98.47 L 568.41 102.16 Z",
    fill: "#ffffff",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe flex-start",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 145,
      marginLeft: 573
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #232F3E; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(35, 47, 62)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "nowrap"
    }
  }, "API Gateway")))), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 573,
    y: 157,
    fill: "#232F3E",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "API Gateway")))), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M 534.19 180 L 612.19 180 L 612.19 258 L 534.19 258 Z",
    fill: "url(#mx-gradient-f78e04-1-d05c17-1-s-0)",
    stroke: "none",
    pointerEvents: "all"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M 559.86 247.97 L 546.02 247.97 L 561.32 215.99 L 568.25 230.26 Z M 562.32 212.93 C 562.13 212.55 561.74 212.3 561.32 212.3 L 561.31 212.3 C 560.88 212.3 560.49 212.55 560.31 212.94 L 543.24 248.61 C 543.08 248.95 543.1 249.36 543.3 249.68 C 543.51 250 543.87 250.2 544.25 250.2 L 560.56 250.2 C 560.99 250.2 561.39 249.95 561.57 249.56 L 570.5 230.73 C 570.65 230.43 570.65 230.07 570.5 229.77 Z M 601.07 247.97 L 587.32 247.97 L 565.27 201.81 C 565.09 201.42 564.69 201.17 564.26 201.17 L 555.27 201.17 L 555.28 190.03 L 572.91 190.03 L 594.86 236.19 C 595.04 236.58 595.44 236.83 595.87 236.83 L 601.07 236.83 Z M 602.19 234.6 L 596.57 234.6 L 574.62 188.44 C 574.44 188.05 574.04 187.8 573.61 187.8 L 554.16 187.8 C 553.55 187.8 553.05 188.3 553.04 188.91 L 553.03 202.28 C 553.03 202.58 553.15 202.86 553.36 203.07 C 553.57 203.28 553.85 203.4 554.15 203.4 L 563.56 203.4 L 585.61 249.56 C 585.8 249.95 586.19 250.2 586.62 250.2 L 602.19 250.2 C 602.8 250.2 603.3 249.7 603.3 249.09 L 603.3 235.71 C 603.3 235.1 602.8 234.6 602.19 234.6 Z",
    fill: "#ffffff",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe flex-start",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 265,
      marginLeft: 573
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #232F3E; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(35, 47, 62)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "nowrap"
    }
  }, "Lambda")))), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 573,
    y: 277,
    fill: "#232F3E",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "Lambda")))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 30,
    width: 190,
    height: 20,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 40,
      marginLeft: 125
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "nowrap"
    }
  }, "AWS Environment dev, uat, prod")))), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 125,
    y: 44,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "AWS Environment dev, uat, prod"))))), _switch || (_switch = /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("g", {
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }), /*#__PURE__*/React.createElement("a", {
    transform: "translate(0,-5)",
    xlinkHref: "https://www.diagrams.net/doc/faq/svg-export-text-problems",
    target: "_blank"
  }, /*#__PURE__*/React.createElement("text", {
    textAnchor: "middle",
    fontSize: "10px",
    x: "50%",
    y: "100%"
  }, "Text is not SVG - cannot display")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApiDevOps);
export default __webpack_public_path__ + "static/media/API-DevOps.12c03b2b30ae725a5a91621b53d4fe83.svg";
export { ForwardRef as ReactComponent };